import GoogleAnalyticsIcon from './modules/GoogleAnalytics/assets/google-analytics-icon.svg';
export const externalSourceIcons = {
    'google-analytics': GoogleAnalyticsIcon,
};
